import logo from '../../../../assets/permulink_icono.png';
import styles from './MainIcon.module.css';

interface props {
    iconSize?: number;
    imagotype?: boolean;
}

export const MainIcon = ({ iconSize = 50, imagotype = false }: props) => {
  return (
    <div className={styles.container}>
      <div className={styles.iconContainer} style={{width: iconSize, height: iconSize}}>
        <img src={logo} alt="Main Icon" style={{width: '100%', height: '100%'}} />
      </div>
      {imagotype && <span className={styles.mainIconText} style={{fontSize: iconSize / 2.4}}>PermuLink</span>}
    </div>
  );
};